import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How you can start using GraphQL today without changing the backend",
  "description": "",
  "published": "2020-03-12T00:00:00.000Z",
  "redirect_from": ["/blog/how-you-can-start-using-graphql-today-without-changing-the-backend/swizec/9350"],
  "categories": "Back End, Technical",
  "hero": "./img/h5gaIXC.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`GraphQL for new projects looks great ... buuuut how do you use it with that old backend cobbled together in Rails over the last bazillion years?`}</p>
    </blockquote>
    <p>{`Can you write an async function that returns some data? Great! That's all GraphQL needs. 🤘`}</p>
    <p>{`No seriously, it's `}<em parentName="p">{`that`}</em>{` simple.`}</p>
    <p>{`You can connect GraphQL to your REST API instead of the database. Create a small proxy and start using GraphQL on the frontend today. No backend changes required.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a02045e9876466b101644ae75a22fb90/b41cb/h5gaIXC.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "58.744394618834086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'236\\'%20viewBox=\\'0%200%20400%20236\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M43%206c-8%201-11%202-12%206-4%209-5%2053-2%2058%202%204%204%204%2022%204%2022-1%2021-1%2021-8%200-5-2-4-2%201v4l-10%201c-13%202-28%201-30-1a209%20209%200%20012-55c1-7%209-11%2011-5%200%202%201%202%208%202%208%200%2011-1%2011-5l4-1c3%200%204%200%205%203v51l3-44C73%204%2073%204%2043%206m20%2017c-1%201-3%202-3%204-1%202-2%202-7%201l-8%201c-4%202-4%203%201%201%203-1%2010-1%2013%201l4%201c4%201%204%201%205-2%203-6%201-9-5-7m279%201h-21v5c-2%2018-3%2048-3%2079v36l6%201h19c19-1%2039%200%2040%203a1094%201094%200%20017-88l2-26-1-8h-6l-13-1c-9-2-19-2-30-1m3%201l-12%201h-11l-1%2021-2%2058v37l3%201h54l7%201v-7a28661%2028661%200%20015-75c2-16%202-32%201-33l-7-1-8-1c-2-2-28-3-29-2M85%2045l4%202%2011%205%2012%207c7%203%2025%2017%2025%2018l-5-2-4-1%2012%206V70c-1-6-2-5-1%202l-1%206v-1c0-2-17-15-28-21L86%2044c-1%200-2%200-1%201m1%2010l5%208v-4l11%207%2028%2014c1-1-3-3-9-6a187%20187%200%2001-26-15c-2-1-2-1%200-1a815%20815%200%2001-9-3m82%2012l-3%203c0%203%202%202%205%200%206-5%2011-1%2012%2012v7l-4%201c-5%203-19%2016-17%2017l5-2c17-12%2017-12%2017-6%200%204%205%2013%207%2013l2-1c-4-8-5-11-6-20-2-21-4-26-11-26l-7%202M81%2096H44a1512%201512%200%200051%201h9l-1%207-3%2022c-5%2017-6%2024-7%2039s1%2012%203-6c1-17%202-21%206-34l3-19%201-9c4-2-7-3-25-1m-66%202l-3%2016a1019%201019%200%2001-7%2070l7-1c6-2%209-2%2031-3%2035%200%2055-1%2051-2l-10-1a1108%201108%200%2001-73%204l-5%202%202-17%203-24a677%20677%200%20014-44m225%203c-6%204-6%207-1%207a465%20465%200%20016-1l-5-1c2-3%2030-2%2044%201l14%202c3-2-27-6-42-6-12%200-15%200-13-1%203-1%204-3%202-3l-5%202m-191%206l-12%202h-9c-3%203%2014%204%2021%201%205-1%207-2%209-1h6l6-1c3%201%205%200%203-2-3-1-20-1-24%201m94%202l1%202-15%209c-18%209-24%2013-24%2014l3-1%2020-11c9-4%2018-9%2019-11%204-3%204-1-1%203l-3%205%2010-10h-10m-114%207c-4%201-4%207-1%2010%202%202%208%200%2013-2%202-2%201-8-1-8H29m118%204a396%20396%200%2001-37%2021l-3%201c-2%200%200-3%204-5%202%200%203-2%202-2%200-1-8%204-8%206-1%202%200%203%206%202s8-3%204-3l16-10a327%20327%200%200016-10M33%20158c-1%202-2%202-5%201-4-1-10%200-10%201h3l7%201c3%202%205%202%206%201l8-1c9%201%2011-2%203-3l-7-2-5%202m354%2014l-3%204h-2c-2-2-4-3-4-1s-3%204-6%204h-2l1-2c-2%200-2%200-1-1l3-1%202-1c0-2-7-1-8%202-2%205%201%208%206%205h3l2-2c1-3%201-3%203-1%202%201%202%201%205-2l3-3v4c0%203%200%204%203%204%202%200%203-1%203-3%201-5-5-9-8-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a02045e9876466b101644ae75a22fb90/ca0a1/h5gaIXC.webp 223w", "/static/a02045e9876466b101644ae75a22fb90/75680/h5gaIXC.webp 445w", "/static/a02045e9876466b101644ae75a22fb90/8d1ba/h5gaIXC.webp 890w", "/static/a02045e9876466b101644ae75a22fb90/3838e/h5gaIXC.webp 1335w", "/static/a02045e9876466b101644ae75a22fb90/e0991/h5gaIXC.webp 1661w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a02045e9876466b101644ae75a22fb90/e92b6/h5gaIXC.png 223w", "/static/a02045e9876466b101644ae75a22fb90/e66bf/h5gaIXC.png 445w", "/static/a02045e9876466b101644ae75a22fb90/4ef49/h5gaIXC.png 890w", "/static/a02045e9876466b101644ae75a22fb90/4e814/h5gaIXC.png 1335w", "/static/a02045e9876466b101644ae75a22fb90/b41cb/h5gaIXC.png 1661w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/a02045e9876466b101644ae75a22fb90/4ef49/h5gaIXC.png",
              "alt": "h5gaIXC",
              "title": "h5gaIXC",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`We explored this idea on a stream 👇`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=5d_CZHljxuw"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20120v105h401V14l-1%20101v102l-4-1-3%201v1h-2c0-2%200-2-2%200h-1c0-1-1-2-3-2s-3%200-3%203c0%202%200%203-3%203s-3%200-3-3c1-2%200-3-2-3s-2%201-2%203c0%203%200%203-4%203-3%200-3%200-1-1l1-1%201-1%203-1h-3l-4%202c-1%201-1%201-1-1v-3h-20l-22-1c-1-1-2-20-2-51v-11H218l-1-69V15H0v105m0%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2b8a71e7e3040608947a3db3ebfd2441/ca0a1/techletter.app-screenshot-1584029350206.webp 223w", "/static/2b8a71e7e3040608947a3db3ebfd2441/75680/techletter.app-screenshot-1584029350206.webp 445w", "/static/2b8a71e7e3040608947a3db3ebfd2441/0ba47/techletter.app-screenshot-1584029350206.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2b8a71e7e3040608947a3db3ebfd2441/e92b6/techletter.app-screenshot-1584029350206.png 223w", "/static/2b8a71e7e3040608947a3db3ebfd2441/e66bf/techletter.app-screenshot-1584029350206.png 445w", "/static/2b8a71e7e3040608947a3db3ebfd2441/6af66/techletter.app-screenshot-1584029350206.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2b8a71e7e3040608947a3db3ebfd2441/6af66/techletter.app-screenshot-1584029350206.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Out came a proof of concept that took a 37KB payload from our production API at `}<a parentName="p" {...{
        "href": "https://yup.com"
      }}>{`Yup`}</a>{` and turned it into this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5c620b2cab3c92eaad106b275b5cd162/647f4/YKXYMJT.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.50224215246637%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'226\\'%20viewBox=\\'0%200%20400%20226\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20113v113h401V0H0v113m200-66c-8%206-3%2019%208%2019%204%200%2010-5%2010-9%202-10-10-17-18-10\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5c620b2cab3c92eaad106b275b5cd162/ca0a1/YKXYMJT.webp 223w", "/static/5c620b2cab3c92eaad106b275b5cd162/75680/YKXYMJT.webp 445w", "/static/5c620b2cab3c92eaad106b275b5cd162/8d1ba/YKXYMJT.webp 890w", "/static/5c620b2cab3c92eaad106b275b5cd162/3838e/YKXYMJT.webp 1335w", "/static/5c620b2cab3c92eaad106b275b5cd162/e11e5/YKXYMJT.webp 1780w", "/static/5c620b2cab3c92eaad106b275b5cd162/89f34/YKXYMJT.webp 2682w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5c620b2cab3c92eaad106b275b5cd162/e92b6/YKXYMJT.png 223w", "/static/5c620b2cab3c92eaad106b275b5cd162/e66bf/YKXYMJT.png 445w", "/static/5c620b2cab3c92eaad106b275b5cd162/4ef49/YKXYMJT.png 890w", "/static/5c620b2cab3c92eaad106b275b5cd162/4e814/YKXYMJT.png 1335w", "/static/5c620b2cab3c92eaad106b275b5cd162/701e9/YKXYMJT.png 1780w", "/static/5c620b2cab3c92eaad106b275b5cd162/647f4/YKXYMJT.png 2682w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/5c620b2cab3c92eaad106b275b5cd162/4ef49/YKXYMJT.png",
              "alt": "YKXYMJT",
              "title": "YKXYMJT",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`😍`}</p>
    <h2 {...{
      "id": "why-wrap-a-production-api-in-graphql"
    }}>{`Why wrap a production API in GraphQL`}</h2>
    <p>{`37KB for `}<em parentName="p">{`one request`}</em>{` isn't even the biggest API payload we've got. It's just the most common 👉 `}<em parentName="p">{`our entire settings object`}</em>{`.`}</p>
    <p>{`Nobody even knows which of those fields are still in use. Can't remove any because you might break an old client.`}</p>
    <p>{`So forever more every client gets every setting that any client in history ever needed.`}</p>
    <p><img parentName="p" {...{
        "src": "/62b2e4fd9653680d367ecd7ecf2ba619/media-aNtt9T8SqGNK8-giphy.gif",
        "alt": "ew giphy"
      }}></img></p>
    <p>{`With a GraphQL proxy, each client can take just what it needs.`}</p>
    <p>{`It works like this:`}</p>
    <ol>
      <li parentName="ol">{`Client sends GraphQL query`}</li>
      <li parentName="ol">{`GraphQL proxy gets query and maps it to the `}<inlineCode parentName="li">{`settings`}</inlineCode>{` resolver`}</li>
      <li parentName="ol">{`Resolver makes `}<inlineCode parentName="li">{`fetch()`}</inlineCode>{` request to API`}</li>
      <li parentName="ol">{`API returns full settings object`}</li>
      <li parentName="ol">{`GraphQL machinery matches object to query`}</li>
      <li parentName="ol">{`Proxy returns only the requested data`}</li>
    </ol>
    <p>{`Want to combine multiple API requests into one? Now you can! Just send 2 queries in 1 request.`}</p>
    <p>{`Users get a faster app and lower bandwidth usage.`}</p>
    <p>{`You get an easier coding experience on the client `}<em parentName="p">{`and`}</em>{` you empower frontend engineers to make better decisions.`}</p>
    <p>{`Worried about the overhead of a GraphQL proxy?`}</p>
    <p>{`Many requests can be cached and don't even have to hit your real backend.`}</p>
    <h2 {...{
      "id": "how-to-wrap-a-rest-api-with-graphql"
    }}>{`How to wrap a REST API with GraphQL`}</h2>
    <ol>
      <li parentName="ol">{`Create a GraphQL server`}</li>
      <li parentName="ol">{`Write query resolvers that poke your API`}</li>
      <li parentName="ol">{`Build GraphQL type definitions from your payloads`}</li>
    </ol>
    <p>{`That last part is tedious, I'm sorry.`}</p>
    <p>{`Wittern et al talk about `}<a parentName="p" {...{
        "href": "https://arxiv.org/abs/1809.08319"
      }}>{`Generating GraphQL-Wrappers for REST APIs`}</a>{` in a 2018 paper, but I haven't found a good implementation in the wild yet. `}<a parentName="p" {...{
        "href": "https://hasura.io/"
      }}>{`Hasura`}</a>{` looks like a great approach, but they convert your Postgres schema into a GraphQL API, not your client-facing API.`}</p>
    <p>{`How related are your Postgres and your REST API really? I bet you build those payloads from SQL queries, environment variables, helper methods, and all sorts of stuff.`}</p>
    <p>{`WalmartLabs created a `}<a parentName="p" {...{
        "href": "https://walmartlabs.github.io/json-to-simple-graphql-schema/"
      }}>{`JSON-to-GraphQL`}</a>{` library that works well for a first pass. I used it on the stream.`}</p>
    <p>{`You could create a crawler that goes through your API and builds GraphQL type definitions. 🤔`}</p>
    <h2 {...{
      "id": "build-a-proof-of-concept-to-impress-your-boss"
    }}>{`Build a proof-of-concept to impress your boss.`}</h2>
    <p>{`After harping on and on that we need GraphQL and it will solve many of our problems, my team started getting tired of my shit. We can't do it, it's too hard, we don't want to change the backend, we ... screw you I'm building it.`}</p>
    <p>{`here's what I found`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/graphql-rest-proxy"
      }}>{`full code on Github`}</a></p>
    <h3 {...{
      "id": "serverlessyml"
    }}>{`serverless.yml`}</h3>
    <p>{`Host on AWS Lambda so you don't have to deal with servers. Focus on the code.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=yaml&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=service%3A%20yup-graphql-proxy%0A%0Aprovider%3A%0A%20%20%20%20name%3A%20aws%0A%20%20%20%20runtime%3A%20nodejs12.x%0A%20%20%20%20stage%3A%20dev%0A%0Afunctions%3A%0A%20%20%20%20graphql%3A%0A%20%20%20%20%20%20%20%20handler%3A%20dist%2Fgraphql.handler%0A%20%20%20%20%20%20%20%20events%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20http%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20path%3A%20graphql%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20method%3A%20GET%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20cors%3A%20true%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20http%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20path%3A%20graphql%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20method%3A%20POST%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20cors%3A%20true"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "398px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "128.2511210762332%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'514\\'%20viewBox=\\'0%200%20400%20514\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M34%2050c-2%202-2%20413%201%20415%202%203%20329%203%20331%200%203-2%203-413%201-415S36%2048%2034%2050m36%2016c-6%206%203%2013%208%208l2-4c0-5-7-8-10-4m20%200c-3%203-3%205%200%208%204%203%204%203%208-1%201-1%202-3%201-4-1-5-6-6-9-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/22bbf0af0f272fb1bf8b1c39a6b09da1/ca0a1/techletter.app-screenshot-1584029348368.webp 223w", "/static/22bbf0af0f272fb1bf8b1c39a6b09da1/579c2/techletter.app-screenshot-1584029348368.webp 398w"],
                "sizes": "(max-width: 398px) 100vw, 398px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/22bbf0af0f272fb1bf8b1c39a6b09da1/e92b6/techletter.app-screenshot-1584029348368.png 223w", "/static/22bbf0af0f272fb1bf8b1c39a6b09da1/692d4/techletter.app-screenshot-1584029348368.png 398w"],
                "sizes": "(max-width: 398px) 100vw, 398px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/22bbf0af0f272fb1bf8b1c39a6b09da1/692d4/techletter.app-screenshot-1584029348368.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Run `}<inlineCode parentName="p">{`sls deploy`}</inlineCode>{` and you get a server that runs your `}<inlineCode parentName="p">{`graphql.handler`}</inlineCode>{` method on every GET and POST request.`}</p>
    <h3 {...{
      "id": "graphqlts--apollo-aws-lambda-server"
    }}>{`graphql.ts – Apollo AWS Lambda server`}</h3>
    <p>{`Apollo is great for building GraphQL servers. Good community support, integrates well with Lambda, great developer experience. 👌`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Fgraphql.ts%0Aimport%20%7B%20ApolloServer%2C%20gql%20%7D%20from%20%22apollo-server-lambda%22%3B%0Aimport%20%7B%20APIwrapper%20%7D%20from%20%22.%2FAPIwrapper%22%3B%0Aimport%20%7B%20settingsSchema%20%7D%20from%20%22.%2Fschema%2FSettings%22%3B%0A%0A%2F%2F%20this%20is%20where%20we%20define%20the%20shape%20of%20our%20API%0Aconst%20rootSchema%20%3D%20gql%60%0A%20%20%20%20type%20Query%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20queries%20%E2%80%93%C2%A0GET%20api%0A%20%20%20%20%7D%0A%20%20%20%20%0A%20%20%20%20type%20Mutation%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20mutations%20%E2%80%93%C2%A0POST%20api%0A%20%20%20%20%7D%0A%60%3B%0A%0Aconst%20typeDefs%20%3D%20%5BrootSchema%2C%20settingsSchema%5D%3B%0A%0A%2F%2F%20a%20convenience%20wrapper%20for%20your%20API%0Aconst%20API%20%3D%20new%20APIwrapper()%3B%0A%0A%2F%2F%20this%20is%20where%20the%20shape%20maps%20to%20functions%0Aconst%20resolvers%20%3D%20%7B%0A%20%20%20%20Query%3A%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20query%20resolvers%20go%20here%0A%20%20%20%20%7D%0A%20%20%20%20Mutation%3A%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20mutation%20resolvers%20go%20here%0A%20%20%20%20%7D%0A%7D%3B%0A%0Aconst%20server%20%3D%20new%20ApolloServer(%7B%20typeDefs%2C%20resolvers%20%7D)%3B%0A%0Aexport%20const%20handler%20%3D%20server.createHandler(%7B%0A%20%20%20%20cors%3A%20%7B%0A%20%20%20%20%20%20%20%20origin%3A%20%22*%22%2C%20%2F%2F%20for%20security%20in%20production%2C%20lock%20this%20to%20your%20real%20endpoints%0A%20%20%20%20%20%20%20%20credentials%3A%20true%0A%20%20%20%20%7D%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "774px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "112.55605381165918%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'450\\'%20viewBox=\\'0%200%20400%20450\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M17%2036c-2%2021-1%20387%200%20389%202%202%20364%202%20366%200%201-2%202-368%200-389V25H17v11\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/14d6d3629ab0a7a843b28276dd9056e8/ca0a1/techletter.app-screenshot-1584029348184.webp 223w", "/static/14d6d3629ab0a7a843b28276dd9056e8/75680/techletter.app-screenshot-1584029348184.webp 445w", "/static/14d6d3629ab0a7a843b28276dd9056e8/9b58d/techletter.app-screenshot-1584029348184.webp 774w"],
                "sizes": "(max-width: 774px) 100vw, 774px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/14d6d3629ab0a7a843b28276dd9056e8/e92b6/techletter.app-screenshot-1584029348184.png 223w", "/static/14d6d3629ab0a7a843b28276dd9056e8/e66bf/techletter.app-screenshot-1584029348184.png 445w", "/static/14d6d3629ab0a7a843b28276dd9056e8/41d3b/techletter.app-screenshot-1584029348184.png 774w"],
                "sizes": "(max-width: 774px) 100vw, 774px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/14d6d3629ab0a7a843b28276dd9056e8/41d3b/techletter.app-screenshot-1584029348184.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This creates a GraphQL server. Send a POST request and it maps queries to resolvers. Send a GET request and you see an Apollo playground so you can try your queries.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5c620b2cab3c92eaad106b275b5cd162/647f4/YKXYMJT.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.50224215246637%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'226\\'%20viewBox=\\'0%200%20400%20226\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20113v113h401V0H0v113m200-66c-8%206-3%2019%208%2019%204%200%2010-5%2010-9%202-10-10-17-18-10\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5c620b2cab3c92eaad106b275b5cd162/ca0a1/YKXYMJT.webp 223w", "/static/5c620b2cab3c92eaad106b275b5cd162/75680/YKXYMJT.webp 445w", "/static/5c620b2cab3c92eaad106b275b5cd162/8d1ba/YKXYMJT.webp 890w", "/static/5c620b2cab3c92eaad106b275b5cd162/3838e/YKXYMJT.webp 1335w", "/static/5c620b2cab3c92eaad106b275b5cd162/e11e5/YKXYMJT.webp 1780w", "/static/5c620b2cab3c92eaad106b275b5cd162/89f34/YKXYMJT.webp 2682w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5c620b2cab3c92eaad106b275b5cd162/e92b6/YKXYMJT.png 223w", "/static/5c620b2cab3c92eaad106b275b5cd162/e66bf/YKXYMJT.png 445w", "/static/5c620b2cab3c92eaad106b275b5cd162/4ef49/YKXYMJT.png 890w", "/static/5c620b2cab3c92eaad106b275b5cd162/4e814/YKXYMJT.png 1335w", "/static/5c620b2cab3c92eaad106b275b5cd162/701e9/YKXYMJT.png 1780w", "/static/5c620b2cab3c92eaad106b275b5cd162/647f4/YKXYMJT.png 2682w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/5c620b2cab3c92eaad106b275b5cd162/4ef49/YKXYMJT.png",
              "alt": "YKXYMJT",
              "title": "YKXYMJT",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "schemas"
    }}>{`schemas`}</h3>
    <p>{`Schemas represent the shape of your API.`}</p>
    <p>{`This will take some manual work. I recommend a Query for every GET endpoint in your API and a Mutation for every POST/PUT/DELETE etc.`}</p>
    <p>{`Then use something like the `}<a parentName="p" {...{
        "href": "https://walmartlabs.github.io/json-to-simple-graphql-schema/"
      }}>{`walmartlabs schema generator`}</a>{` to build type definitions for each endpoint. Some might overlap and that's okay.`}</p>
    <p>{`To keep code organized I recommend 1 schema file per endpoint – `}<inlineCode parentName="p">{`src/schema/Thing.ts`}</inlineCode>{`. Like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=src%2Fschema%2FSettings.ts%0A%0Aimport%20%7B%20gql%20%7D%20from%20%22apollo-server%22%3B%0A%0A%2F%2F%20schema%20generated%20with%3A%20https%3A%2F%2Fwalmartlabs.github.io%2Fjson-to-simple-graphql-schema%2F%0Aexport%20const%20settingsSchema%20%3D%20gql%60%0A%20%20%20%20type%20Reactions%20%7B%0A%20%20%20%20%20%20%20%20name%3A%20String%0A%20%20%20%20%20%20%20%20emoji%3A%20String%0A%20%20%20%20%20%20%20%20label%3A%20String%0A%20%20%20%20%7D%0A%0A%20%20%20%20type%20Subtopics%20%7B%0A%20%20%20%20%20%20%20%20id%3A%20Int%0A%20%20%20%20%20%20%20%20name%3A%20String%0A%20%20%20%20%20%20%20%20label%3A%20String%0A%20%20%20%20%7D%0A%0A%20%20%20%20type%20Subjects%20%7B%0A%20%20%20%20%20%20%20%20id%3A%20Int%0A%20%20%20%20%20%20%20%20name%3A%20String%0A%20%20%20%20%20%20%20%20blurb%3A%20String%0A%20%20%20%20%20%20%20%20available%3A%20Boolean%0A%20%20%20%20%20%20%20%20%0A%2F%2F%20...%0A%20%20%20%20%7D%0A%60%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "790px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.95964125560539%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'332\\'%20viewBox=\\'0%200%20400%20332\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M16%2026v142l1%20140h367V26l-184-1-184%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/18c269d80ef1d8256444c0415b35a1de/ca0a1/techletter.app-screenshot-1584029348191.webp 223w", "/static/18c269d80ef1d8256444c0415b35a1de/75680/techletter.app-screenshot-1584029348191.webp 445w", "/static/18c269d80ef1d8256444c0415b35a1de/02aff/techletter.app-screenshot-1584029348191.webp 790w"],
                "sizes": "(max-width: 790px) 100vw, 790px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/18c269d80ef1d8256444c0415b35a1de/e92b6/techletter.app-screenshot-1584029348191.png 223w", "/static/18c269d80ef1d8256444c0415b35a1de/e66bf/techletter.app-screenshot-1584029348191.png 445w", "/static/18c269d80ef1d8256444c0415b35a1de/2e237/techletter.app-screenshot-1584029348191.png 790w"],
                "sizes": "(max-width: 790px) 100vw, 790px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/18c269d80ef1d8256444c0415b35a1de/2e237/techletter.app-screenshot-1584029348191.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`There's 300 lines of this crap. You don't wanna write it by hand from scratch 😅`}</p>
    <p>{`A crawler could be a good idea. Something you point at all the different endpoints and it collects those schema definitions.`}</p>
    <p>{`You'll have to consolidate and clean up by hand.`}</p>
    <h3 {...{
      "id": "combining-all-those-schemas"
    }}>{`combining all those schemas`}</h3>
    <p>{`Get all your schemas imported and into an array, pass them into ApolloServer as type definitions.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Fgraphql.ts%0A%0Aimport%20%7B%20userSchema%20%7D%20from%20%22.%2Fschema%2FUser%22%3B%0Aimport%20%7B%20settingsSchema%20%7D%20from%20%22.%2Fschema%2FSettings%22%3B%0A%0Aconst%20rootSchema%20%3D%20gql%60%0A%20%20%20%20type%20Query%20%7B%0A%20%20%20%20%20%20%20%20user%3A%20User%0A%20%20%20%20%20%20%20%20settings%3A%20Settings%0A%20%20%20%20%7D%0A%60%3B%0A%0Aconst%20typeDefs%20%3D%20%5BrootSchema%2C%20userSchema%2C%20settingsSchema%5D%3B%0A%0Aconst%20server%20%3D%20new%20ApolloServer(%7B%20typeDefs%2C%20resolvers%20%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "566px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "77.57847533632287%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'310\\'%20viewBox=\\'0%200%20400%20310\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2036a5285%205285%200%20001%20240h352l1-120V36c-1-3-353-3-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/31da4c02df05fd756ad8aa8b43f32783/ca0a1/techletter.app-screenshot-1584029348174.webp 223w", "/static/31da4c02df05fd756ad8aa8b43f32783/75680/techletter.app-screenshot-1584029348174.webp 445w", "/static/31da4c02df05fd756ad8aa8b43f32783/3161c/techletter.app-screenshot-1584029348174.webp 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/31da4c02df05fd756ad8aa8b43f32783/e92b6/techletter.app-screenshot-1584029348174.png 223w", "/static/31da4c02df05fd756ad8aa8b43f32783/e66bf/techletter.app-screenshot-1584029348174.png 445w", "/static/31da4c02df05fd756ad8aa8b43f32783/6fe44/techletter.app-screenshot-1584029348174.png 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/31da4c02df05fd756ad8aa8b43f32783/6fe44/techletter.app-screenshot-1584029348174.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Query `}<inlineCode parentName="p">{`user`}</inlineCode>{` returns the `}<inlineCode parentName="p">{`User`}</inlineCode>{` model, `}<inlineCode parentName="p">{`settings`}</inlineCode>{` for `}<inlineCode parentName="p">{`Settings`}</inlineCode>{` etc. Build a mapping that makes sense for your API.`}</p>
    <p>{`Remember that you can `}<inlineCode parentName="p">{`extend type`}</inlineCode>{` in any schema to extend existing types. Great for adding queries and mutations.`}</p>
    <h3 {...{
      "id": "map-queries-to-rest-requests-with-resolvers"
    }}>{`map queries to REST requests with resolvers`}</h3>
    <p>{`Resolvers are where you map queries to data. Any data from anywhere. 🤘`}</p>
    <p>{`For my settings proof-of-concept, it looks like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Fgraphql.ts%0A%0Aconst%20API%20%3D%20new%20APIwrapper()%3B%0A%0A%2F%2F%20this%20is%20where%20the%20shape%20maps%20to%20functions%0Aconst%20resolvers%20%3D%20%7B%0A%20%20%20%20Query%3A%20%7B%0A%20%20%20%20%20%20%20%20settings%3A%20async%20()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20await%20API.login()%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20return%20API.settings()%3B%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%20%20%20%20%2F%2F%20Mutation%3A%20%7B%7D%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "454px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "92.82511210762333%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'371\\'%20viewBox=\\'0%200%20400%20371\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044c-2%202-2%2013-2%20142v141l2%201c2%202%2020%202%20170%202s168%200%20170-2l2-1V186c0-135%200-141-2-142-3-3-338-3-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5fbdc2967af5490e3adf7fc1e925e233/ca0a1/techletter.app-screenshot-1584029348370.webp 223w", "/static/5fbdc2967af5490e3adf7fc1e925e233/75680/techletter.app-screenshot-1584029348370.webp 445w", "/static/5fbdc2967af5490e3adf7fc1e925e233/44d9f/techletter.app-screenshot-1584029348370.webp 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5fbdc2967af5490e3adf7fc1e925e233/e92b6/techletter.app-screenshot-1584029348370.png 223w", "/static/5fbdc2967af5490e3adf7fc1e925e233/e66bf/techletter.app-screenshot-1584029348370.png 445w", "/static/5fbdc2967af5490e3adf7fc1e925e233/b3c1d/techletter.app-screenshot-1584029348370.png 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5fbdc2967af5490e3adf7fc1e925e233/b3c1d/techletter.app-screenshot-1584029348370.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`An API wrapper helps with authentication, staying logged in as a user, and sending the right headers with each request.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`API.settings()`}</inlineCode>{` method sends a fetch request to `}<inlineCode parentName="p">{`/api/settings`}</inlineCode>{` and returns the payload.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2FAPIwrapper.ts%0A%0Aimport%20fetch%20from%20%22isomorphic-fetch%22%3B%0A%0Aexport%20class%20APIwrapper%20%7B%0A%20%20%20%20headers%3A%20JSONBlob%20%3D%20%7B%0A%20%20%20%20%20%20%20%20%22Content-Type%22%3A%20%22application%2Fjson%22%2C%0A%20%20%20%20%20%20%20%20Authorization%3A%20%60Token%20token%3D%3Cauth_token%3E%60%2C%0A%20%20%20%20%20%20%20%20Accept%3A%20%22application%2Fjson.v2%22%0A%20%20%20%20%7D%3B%0A%0A%20%20%20%20async%20settings()%20%7B%0A%20%20%20%20%20%20%20%20await%20this.login()%3B%0A%0A%20%20%20%20%20%20%20%20const%20settings%20%3D%20await%20fetch(%22https%3A%2F%2Fswizec.ngrok.io%2Fapi%2Fsettings%22%2C%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20headers%3A%20this.headers%0A%20%20%20%20%20%20%20%20%7D).then(res%20%3D%3E%20res.json())%3B%0A%0A%20%20%20%20%20%20%20%20return%20settings%3B%0A%20%20%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "726px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.33632286995517%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'301\\'%20viewBox=\\'0%200%20400%20301\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2027l-1%20124v124h364V27l-182-1-181%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38cc2f33b6d96aaef96ef637d651b3f7/ca0a1/techletter.app-screenshot-1584029348135.webp 223w", "/static/38cc2f33b6d96aaef96ef637d651b3f7/75680/techletter.app-screenshot-1584029348135.webp 445w", "/static/38cc2f33b6d96aaef96ef637d651b3f7/06b0e/techletter.app-screenshot-1584029348135.webp 726w"],
                "sizes": "(max-width: 726px) 100vw, 726px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38cc2f33b6d96aaef96ef637d651b3f7/e92b6/techletter.app-screenshot-1584029348135.png 223w", "/static/38cc2f33b6d96aaef96ef637d651b3f7/e66bf/techletter.app-screenshot-1584029348135.png 445w", "/static/38cc2f33b6d96aaef96ef637d651b3f7/f8067/techletter.app-screenshot-1584029348135.png 726w"],
                "sizes": "(max-width: 726px) 100vw, 726px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/38cc2f33b6d96aaef96ef637d651b3f7/f8067/techletter.app-screenshot-1584029348135.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Hardcoded to my dev machine because this is just a prototype. You'd want that to be a setting or environment variable of some sort.`}</p>
    <p>{`The headers also are hardcoded and I stripped the token before sharing.`}</p>
    <p>{`My login method also is quite ratchet. It uses a demo user's email/pass combination to fake logging into the server. 🤣`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=async%20login()%20%7B%0A%20%20%20%20if%20(this.headers%5B%22X-Has-User-Account%22%5D)%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20already%20logged%20in%2C%20keep%20going%0A%20%20%20%20%20%20%20%20return%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20const%20response%3A%20LoginResponse%20%3D%20await%20fetch(%0A%20%20%20%20%20%20%20%20%22https%3A%2F%2Fswizec.ngrok.io%2Fapi%2Flogin%22%2C%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20method%3A%20%22POST%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20headers%3A%20this.headers%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20body%3A%20JSON.stringify(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20user%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20email%3A%20%22admin%40localhost.com%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20password%3A%20%22Password1!%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20).then(res%20%3D%3E%20res.json())%3B%0A%0A%20%20%20%20%2F%2F%20add%20login%20stuff%20to%20headers%20for%20other%20methods%0A%20%20%20%20this.headers%20%3D%20%7B%0A%20%20%20%20%20%20%20%20...this.headers%2C%0A%20%20%20%20%20%20%20%20%22X-Has-User-Account%22%3A%20%22true%22%2C%0A%20%20%20%20%20%20%20%20%22X-User-Known-Key%22%3A%20response.identifier%2C%0A%20%20%20%20%20%20%20%20%22X-User-Authentication-Token%22%3A%20response.access_token%0A%20%20%20%20%7D%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "582px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "115.69506726457399%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'463\\'%20viewBox=\\'0%200%20400%20463\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2034l-1%20198c0%20194%200%20197%202%20198h352c2-1%202-4%202-198l-1-198c-2-2-352-2-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a9d8efb2ebbdc8b54d1ccefebe5dee66/ca0a1/techletter.app-screenshot-1584029348257.webp 223w", "/static/a9d8efb2ebbdc8b54d1ccefebe5dee66/75680/techletter.app-screenshot-1584029348257.webp 445w", "/static/a9d8efb2ebbdc8b54d1ccefebe5dee66/f6aeb/techletter.app-screenshot-1584029348257.webp 582w"],
                "sizes": "(max-width: 582px) 100vw, 582px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a9d8efb2ebbdc8b54d1ccefebe5dee66/e92b6/techletter.app-screenshot-1584029348257.png 223w", "/static/a9d8efb2ebbdc8b54d1ccefebe5dee66/e66bf/techletter.app-screenshot-1584029348257.png 445w", "/static/a9d8efb2ebbdc8b54d1ccefebe5dee66/7c1cd/techletter.app-screenshot-1584029348257.png 582w"],
                "sizes": "(max-width: 582px) 100vw, 582px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a9d8efb2ebbdc8b54d1ccefebe5dee66/7c1cd/techletter.app-screenshot-1584029348257.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You'll need to figure this part out for yourself. Authentication depends on your backend implementation. You might not even need it for some requests.`}</p>
    <h2 {...{
      "id": "and-thats-how-you-wrap-your-rest-api-in-a-graphql"
    }}>{`And that's how you wrap your REST API in a GraphQL`}</h2>
    <ol>
      <li parentName="ol">{`GraphQL server`}</li>
      <li parentName="ol">{`Turn payloads into schema`}</li>
      <li parentName="ol">{`Map queries to endpoints`}</li>
    </ol>
    <p>{`Where it gets tricky is preserving end-user authentication. You'd need to get cookie/token information from the client or run the login process through your proxy.`}</p>
    <p>{`Large POST requests could look weird too.`}</p>
    <p>{`We have some endpoints that accept a JSON blob with tens of parameters. Several kilobytes of data. Stuffing all of that into mutation arguments feels funny.`}</p>
    <p>{`Maybe you could have 1 parameter that accepts a JSON string 🤔`}</p>
    <p>{`If you decide to go down this route, expect a schlep followed by `}<em parentName="p">{`"Yay we have GraphQL now"`}</em>{` from everyone else on your team. You'll be their hero.`}</p>
    <p><img parentName="p" {...{
        "src": "/caf4b8cc66b4e9c5d94bd5d3ee65e458/media-ek4CUx2FONgHaMz9V5-giphy-downsized-medium.gif",
        "alt": "hero giphy"
      }}></img></p>
    <p>{`I think it's worth it.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      